/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  ConfigureAPU.tsx
 *
 * Project Title :  Checkout
 *
 * Description	 :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Srinivas Grandhi (E528634)
 *
 * @Date	     : Sep 25, 2019
 *
 * @Version      : Version 1.0
 *
 * By           : Deepthi Bachu (E844276)
 * On           : Oct 03, 2019
 * Description  : Updated code as per ASDS-1470
 *
 * By           : Deepthi Bachu (E844276)
 * On           : Oct 10, 2019
 * Description  : Updated code as per ASDS-1471
 *
 * By           : Sandeepraja (E807238  )
 * On           : Oct 15, 2019
 * Description  : ASDS-1551:  Modal screen Validations (MSA & Non MSA)
 *
 * By           : Deepthi Bachu (E844276)
 * On           : Oct 17, 2019
 * Description  : Updated code as per ASDS-1583
 *
 * By            : SandeepRaja (E807238)
 * On            : Oct 18, 2019
 * Description   : ASDS-1551: Validations in 3 Pop-Ups (MSA & Non MSA)
 *
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Oct 18, 2019
 * Description   : updated the code for ASDS-404
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Nov 1st, 2019
 * Description   : updated the code for ASDS-586
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Nov 4th, 2019
 * Description   : updated the code for ASDS-407
 *
 * By            : H224423
 * On            : Dec 3, 2019
 * Description   : ASDS-1995 - UI Issue Fixes.
 *
 * By            : Deepthi Bachu (E844276)
 * On            : Jan 9th, 2020
 * Description   : updated the code for ASDS-1081
 *
 * By            : H224423
 * On            : Feb 26, 2019
 * Description   : ASDS-2349 - APU Product Features API Integration changes
 *
 * By            : H224423
 * On            : Mar 02, 2019
 * Description   : Update verbiage.
 *
 * By            : H224423
 * On            : 10 Apr, 2020
 * Description   : ASDS-2497 - SIT Issue fixes. Contracts and sub-products API error handling.
 *
 * By            : H422336
 * On            : Sep 11, 2020
 * Description   : ASDS-2741 - UI Enhancement for Phase II
 *
 * By             : H422337
 * On             : Sep 14,2020
 * Description    : ASDS-2753 UI enhancements as part of phase-2
 *
 *By             : H422337
 * On             : Sep 10,2020
 * Description    : ASDS-3140 UI enhancements  phase-2 bugfixes
 *
 * By             : H422336
 * On             : Sep 15,2020
 * Description    : ASDS-3037 UI Enhancements Phase-II
 *
 * By            : H422336
 * On            : Sep 23, 2020
 * Description   : ASDS - 3020 - UI Enhancements for Phase - II
 *
 * By             : H422335
 * On             : Sep 29,2020
 * Description    : ASDS-3226 Non-MSA Purchase type selection page
 *
 * By             : H422337
 * On             : Sep 29,2020
 * Description    : ASDS-3257 APU enhancements as part of phase-2
 *
 * By            : H422336
 * On            : Sep 29, 2020
 * Description   : ASDS - 3233 UI Enhancements for Phase - II
 *
 * By            : H422337
 * On            : Oct 08, 2020
 * Description   : ASDS - 3235 UI Enhancements for Phase - II
 *
 * By            : H422336
 * On            : Oct, 22 2020
 * Description   : ASDS-3535 UI Enhancements for Phase-II
 *
 * By            : H422336
 * On            : Nov 7 2020
 * Description   : ASDS-3832 UI Enhancements for Phase-II
 *
 ******************************************************************************/

import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps, Redirect } from 'react-router-dom';
import { Modal, Button, Stepper, Notification, Grid } from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import './ConfigureAPU.css';
import APUCustomerTypes from '../APUCustomerTypes/APUCustomerTypes';
import MSAAddSerialNumber from './MSAAddSerialNumber';
import MSAConfirmConfiguration from './MSAConfirmConfiguration';
import NonMSAConfigureDetails from './NonMSAConfigureDetails';
import NonMSAPOConfirmConfiguration from './NonMSAPOConfirmConfiguration';
import NonMSAHardwareOptions from './NonMSAHardwareOptions';
import ConfigureAPUActions from '../redux/actions/configure-apu-actions';
import CheckoutConstants, { CheckoutUILabels } from '../constants/checkout-constants';
import routeConstants from '../constants/route-constants';
import NonMSASOConfirmConfugration from './NonMSASOConfirmConfiguration';
import  NonMSAKeyOnlyConfirmConfiguration from './NonMSAKeyOnlyConfirmConfiguration';
import { ContactUsMessage } from '../Common/ContactUsMessage';
import { InLineLoader } from '../Loader/Loader';

interface ICondigureProductState {
    open: any;
    hasClickOut: boolean;
}

interface IConfigureProductProps {
    open: boolean;
    onCancel: any;
    getContractDetails: Function;
    getSubProductDetails: Function;
    productName: string;
    totalPrice: any;
    resetconfigAPUData: Function;
    gotoPrevTabAPU: any;
    gotoNextTabAPU: any;
    apuactiveTab: number;
    customerType: string;
    customerOrderTypeErrorMessage: string;
    enableNextBtn: boolean;
    productId: string;
    redirectTo: string;
    customerOrderType: string;
    showAlertMsg: boolean;
    isAddToCartSuccess: boolean;
    lastProdAddedToCart: string;
    addProductToCartInProgress: boolean;
}

interface IConfigContentProps {
    productId: string;
    apuactiveTab: number;
    customerType: string;
    customerOrderType: string;
}
// Function to return lable for primary button on configuration Modal
function PrimaryButtonLabel(props: any) {
    if ((props.apuactiveTab === 3 && props.customerType === CheckoutConstants.CUSTOMER_CATEGORY_MSA) ||
        (props.apuactiveTab === 4 && props.customerType === CheckoutConstants.CUSTOMER_CATEGORY_NONMSA)) {
        if (props.location.pathname === routeConstants.PURCHASE_SOFTWARE) {
            return CheckoutUILabels.CONFIGURATION_CONFIRM;
        }
        else {
            return CheckoutUILabels.CONFIGURATION_SAVE_BTN;
        }
    } else {
        return CheckoutUILabels.CONFIGURATION_NEXT;
    }
}

function ConfigContent(props: IConfigContentProps) {
    let cardContent;
    if (props.apuactiveTab === 1) {
        cardContent = (
            <APUCustomerTypes/>
        );
    }
    else if (props.apuactiveTab === 2) {
        if (props.customerType === CheckoutConstants.CUSTOMER_CATEGORY_MSA) {
            cardContent = (
                <MSAAddSerialNumber productId={props.productId} />
            );
        }
        else if (props.customerType === CheckoutConstants.CUSTOMER_CATEGORY_NONMSA) {
            cardContent = (
                <NonMSAHardwareOptions />
            );
        }
    }
    else if (props.apuactiveTab === 3) {
        if (props.customerType === CheckoutConstants.CUSTOMER_CATEGORY_MSA) {
            cardContent = (
                <MSAConfirmConfiguration />
            );
        }
        else if (props.customerType === CheckoutConstants.CUSTOMER_CATEGORY_NONMSA) {
            cardContent = (
                <NonMSAConfigureDetails productId={props.productId}/>
            );
        }
    }
    else {
        if (props.customerType === CheckoutConstants.CUSTOMER_CATEGORY_MSA) {
            cardContent = (
                <MSAConfirmConfiguration />
            );
        }
        else if (props.customerType === CheckoutConstants.CUSTOMER_CATEGORY_NONMSA) {
            if (props.customerOrderType === CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_SO){
                cardContent = (
                    <NonMSASOConfirmConfugration/>
                );
            }
            else if(props.customerOrderType === CheckoutConstants.NON_MSA_HW_OPTION_CUSTOMER_PO) {
                cardContent = (
                    <NonMSAPOConfirmConfiguration/>
                );
            }
            else {
                cardContent = (
                    <NonMSAKeyOnlyConfirmConfiguration/>
                );
            }

        }
    }
    return cardContent;
}

class ConfigureAPU extends React.Component<IConfigureProductProps & RouteComponentProps, ICondigureProductState> {
    constructor(props: IConfigureProductProps & RouteComponentProps) {
        super(props);
        this.state = {
            open: props.open,
            hasClickOut: false,
        };
    }

    componentDidMount() {
       this.props.getContractDetails();
        this.props.getSubProductDetails(this.props.productId);
    }

    render() {
        if (this.props.redirectTo) {  // based on this filed will be redirected to my cart page.
            return (
                <Redirect to={this.props.redirectTo}/>
            );
        }
        return (
            // code to open modal
            <React.Fragment>
                {this.renderModal()}
            </React.Fragment>
        );
    }

    // Function to return navigation btn in modal footer
    renderNavigationBtns() {
        return  (
            <Button
                type="primary"
                size="medium"
                // disabled={!this.props.enableNextBtn}
                className="co-primary-button prod-config-next"
                content={PrimaryButtonLabel(this.props)}
                onClick={this.props.gotoNextTabAPU}
            />
        );
    }
    renderModal() {
        const renderNextBtn = this.renderNavigationBtns();

        return (
            <Modal
                closeIcon={true}
                onClose={() => this.props.onCancel(this.props.location.pathname)}
                size="large"
                open={this.props.open}
                closeOnDimmerClick={this.state.hasClickOut}
                closeOnDocumentClick={this.state.hasClickOut}
                className="configure-apu-modal"
            >
                <Modal.Header>
                <div className="ca-modal-heading-text">
                    Product Configuration
                    </div>
                    <div className="ca-modal-product-line">
                        <div className="ca-modal-product-icon">
                            <i className={CheckoutConstants.APU_PRODUCT_CLASSNAME} />
                        </div>
                        <span className="ca-product-name-heading">{this.props.productName}</span>
                    </div>
                </Modal.Header>
                <div className="box">
                    {' '}
                    <Modal.Content>
                        {this.props.showAlertMsg && !this.props.isAddToCartSuccess &&
                            <div>
                                <Notification
                                    hasIcon={true}
                                    title={'Unable to add ' + this.props.lastProdAddedToCart + ' in your cart.'}
                                    severity="critical"
                                >
                                    <ContactUsMessage>Please try again by clicking on Confirm button. {CheckoutUILabels.IF_ISSUE_PERSISTS}</ContactUsMessage>
                                </Notification>
                            </div>
                        }
                        <div className="configure-apu-modal-content">
                        <div className="configure-apu-modal-content-area">
                        {this.props.customerType === CheckoutConstants.CUSTOMER_CATEGORY_MSA ?
                            <Stepper ordered={true} className="stepperClass ca-stepper">
                                <Stepper.Item
                                    title="Select Customer Type"
                                    icon="document-user-profile"
                                    active={this.props.apuactiveTab === 1}
                                    iconRoot="common"
                                    completed={this.props.apuactiveTab > 1}
                                />
                                <Stepper.Item
                                    title="Add APU Serial No."
                                    active={this.props.apuactiveTab === 2}
                                    disabled={this.props.apuactiveTab < 2}
                                    iconRoot="common"
                                    icon="document-settings"
                                    completed={this.props.apuactiveTab > 2}
                                />
                                <Stepper.Item
                                    title="Confirm Configuration"
                                    active={this.props.apuactiveTab === 3}
                                    disabled={this.props.apuactiveTab < 2}
                                    iconRoot="common"
                                    icon="document-confirm"
                                />
                            </Stepper>
                        :
                            <Stepper ordered={true} className="stepperClass ca-stepper">
                                <Stepper.Item
                                    title="Select Customer Type"
                                    icon="document-user-profile"
                                    active={this.props.apuactiveTab === 1}
                                    iconRoot="common"
                                    completed={this.props.apuactiveTab > 1}
                                />
                                <Stepper.Item
                                    title="Select Key Purchase Type"
                                    active={this.props.apuactiveTab === 2}
                                    disabled={this.props.apuactiveTab < 2}
                                    iconRoot="aero"
                                    icon="ac-profile"
                                    completed={this.props.apuactiveTab > 2}
                                />
                                <Stepper.Item
                                    title="Configure Details"
                                    active={this.props.apuactiveTab === 3}
                                    disabled={this.props.apuactiveTab < 3}
                                    iconRoot="common"
                                    icon="document-settings"
                                    completed={this.props.apuactiveTab > 3}
                                />
                                <Stepper.Item
                                    title="Confirm Configuration"
                                    active={this.props.apuactiveTab === 4}
                                    disabled={this.props.apuactiveTab < 3}
                                    iconRoot="common"
                                    icon="document-confirm"
                                />
                            </Stepper>
                        }
                        {this.props.addProductToCartInProgress ?
                             <Grid>
                                <Grid.Row>
                                    <Grid.Column width={12} className="add-to-cart-loader">
                                        <InLineLoader text="Adding to Cart" loading={true} overlayColor="transparent">
                                        </InLineLoader>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid> :
                            <ConfigContent
                                apuactiveTab={this.props.apuactiveTab}
                                customerType={this.props.customerType}
                                productId={this.props.productId}
                                customerOrderType={this.props.customerOrderType}
                            />}
                            </div>
                        </div>
                    </Modal.Content>
                </div>
                <Modal.Footer>
                {
                    this.props.apuactiveTab === 2 &&
                    this.props.customerType === CheckoutConstants.CUSTOMER_CATEGORY_NONMSA &&
                    this.props.customerOrderTypeErrorMessage &&
                    <div className="below-text select-option">
                        <span className="ui error-message">{this.props.customerOrderTypeErrorMessage}
                        </span>
                    </div>
                }
                    <div>
                        {/* if the user is in first step, then show cancel button, else show back button */}
                        {this.props.apuactiveTab === 1 ?
                            <Button
                                type="secondary"
                                content="cancel"
                                className="co-secondary-button"
                                onClick={() => this.props.onCancel(this.props.location.pathname)}
                            />
                            :
                            <Button
                                type="secondary"
                                content="Back"
                                className="co-secondary-button"
                                onClick={this.props.gotoPrevTabAPU}
                            />
                        }
                        {renderNextBtn}
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}

const mapDispatchToProps = {
    getContractDetails: ConfigureAPUActions.getContractDetails,
    getSubProductDetails: ConfigureAPUActions.getSubProductDetails,
    resetconfigAPUData: ConfigureAPUActions.resetconfigAPUData,
    gotoNextTabAPU: ConfigureAPUActions.gotoNextTabAPU,
    gotoPrevTabAPU: ConfigureAPUActions.gotoPrevTabAPU,
    onCancel: ConfigureAPUActions.onCancel,
};

function mapStateToProps(state) {
    const payloadData = state.configAPUData.payload;
    return {
        totalPrice: payloadData.totalPrice,
        apuactiveTab: payloadData.apuactiveTab,
        customerType: payloadData.customerType,
        enableNextBtn: payloadData.enableNextBtn,
        customerOrderTypeErrorMessage: payloadData.customerOrderTypeErrorMessage,
        redirectTo: payloadData.redirectTo,
        customerOrderType: payloadData.customerOrderType,
        showAlertMsg: state.productAlertData.payload.showAlertMsg,
        lastProdAddedToCart: state.productAlertData.payload.lastProdAddedToCart,
        isAddToCartSuccess: state.productAlertData.payload.isAddToCartSuccess,
        addProductToCartInProgress: state.productAlertData.payload.addProductToCartInProgress
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ConfigureAPU));
